import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MatomoRouteInterceptorBase, MatomoTracker } from 'ngx-matomo-client';

export interface PlatformMatomoInterceptorRouteData {
  title: string;
}

@Injectable()
export class PlatformMatomoInterceptor<
  T extends PlatformMatomoInterceptorRouteData = PlatformMatomoInterceptorRouteData
> extends MatomoRouteInterceptorBase<T> {
  /// Temporary code until we go live with the matomo events
  private readonly eventTrackingEnabled = false;
  constructor(protected tracker: MatomoTracker) {
    super();
    this.patchTracker();
  }

  private patchTracker(): void {
    if (this.tracker) {
      const originalTrackEvent = this.tracker.trackEvent.bind(this.tracker);

      this.tracker.trackEvent = (category: string, action: string, name?: string, value?: number): void => {
        if (this.eventTrackingEnabled) {
          originalTrackEvent(category, action, name, value);
        }
      };
    }
  }
  /// Temporary code until we go live with the matomo events

  protected extractRouteData(route: ActivatedRouteSnapshot): T {
    const title: string = route.data.matomoTitle ?? route.url[route.url.length - 1]?.path;
    return { title } as T;
  }

  protected processRouteData(routeData: PlatformMatomoInterceptorRouteData): void {
    this.tracker.setDocumentTitle(routeData.title);
  }
}
